// Packages:
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from 'swiper/modules'
import { NavLink } from "react-router-dom"

//Typescript:
interface heroDataType {
    id: number
    title: string
    description: string
    isHiddenBtn: boolean
    image: string
}

const Hero = () => {
    // Constants:
    const heroDataArr = [
        {
            id: 0,
            title: 'Entrepreneurship for Future Founder',
            description: 'Unlock entrepreneurial potential with our course! From idea generation to team building and market understanding, we guide on every step. ',
            isHiddenBtn: false,
            image: '/assets/Entrepreneurship.gif'
        },
        {
            id: 1,
            title: 'Artificial Intelligence',
            description: "Uncover AI's world in our course. Learn how machines emulate human learning, reasoning, and problem-solving. From algorithms to model building, explore the vast potential and impact of AI technology.",
            isHiddenBtn: true,
            image: '/assets/Artifical_Inteligence.gif'
        },
        {
            id: 2,
            title: 'Ethical Hacking and Cyber Security',
            description: 'Enhance your cybersecurity skills, learn about core security principles, user authentication, NTFS permissions, and more. Gain hands-on experience through live projects like Online Transaction Fraud Detection and Android Video Encryption.',
            isHiddenBtn: true,
            image: '/assets/Cyber_Security.gif'
        },
        {
            id: 3,
            title: 'Graphic Design',
            description: 'Learn the art of designing and planning projects with correct knowledge of placement, layout images, etc. Graphic design programs will help you become a better visualizer and you will learn to execute your thoughts in your designs.',
            isHiddenBtn: true,
            image: '/assets/Graphic_Design.gif'
        },
        {
            id: 4,
            title: '2D Animation',
            description: 'This Program curriculum includes Graphic designing and 2D Animation. You will get an in-depth understanding of design and illustration concepts, designing characters in 2D, rigging and animating them, and also a detailed knowledge of the 12 principles of animation and their uses.',
            isHiddenBtn: true,
            image: '/assets/2D_Animation.gif'
        },
    ]
    return <>
    <div className='col-[2_/_3] row-[2_/_3] w-full overflow-hidden'>

        <div className='w-full'>
        <Swiper
        spaceBetween={20}
        slidesPerView={1} 
        autoplay={{
            delay: 3800, // time in milliseconds
            disableOnInteraction: true, // Control whether autoplay stops on use interaction or not
        }}
        speed={1500} // controls the speed of animation of slider
        draggable={true} // controals where slider can be dragged or not
        loop={true}
        pagination={{
            clickable: true
        }}
        modules={[Pagination, Autoplay]}
        className="mySwiper-hero"
        >
            {heroDataArr?.map((heroData:heroDataType)=><SwiperSlide className='!flex mt-[20px] flex-col hmax md:flex-row justify-between items-center lg:gap-[25px]' key={heroData?.id}>
                    <div className='md:basis-[50%] flex flex-col items-center md:items-start order-2 md:order-1'>
                        <h1 className='md:leading-[60px] text-[32px] md:text-[40px] lg:text-[45px] font-extrabold text-[#1A1A1A]'>{heroData?.title}</h1>
                        <span className='mt-[20px] block w-[80px] h-[4px] bg-[#1A1A1A]'></span>
                        <p className='mt-[30px] text-[18px] md:text-[20px] text-[#3D3D3D]'>{heroData?.description}</p>
                        {!heroData?.isHiddenBtn && <button className='mt-[25px] block font-bold text-[16px] rounded-[2rem] bg-[#F1F8FF] px-[24px] py-[12px]'>eDC IIT Delhi certified</button>}
                        <NavLink to={`/details/${heroData?.id}`} className='mt-[20px] w-max block font-bold text-[16px] rounded-[2rem] bg-[#FF6D28] text-[#F1F8FF] px-[24px] py-[12px]'>More details</NavLink>
                    </div>
                    <img className='object-contain aspect-[627/704] w-[70%] sm:w-[40%] lg:w-[35%] xxl:w-[30%] order-1 md:order-2' src={heroData?.image} alt='Entreprener Course'/>
            </SwiperSlide>)}
        </Swiper>
        </div>
    </div>
    <div className='col-[1_/_-1] row-[2_/_3]' style={{background: 'linear-gradient(to right, #D3E0FF, #82A6FF)'}}></div>
    </>
}

export default Hero